import { addIntoCart, getCartCall } from "../services/mightyWifiApi";
import { GET_CART_REQUEST_SUCESSS, CLEAR_CART } from "./types";

export function addToCart(payload) {
  return dispatch => {
    return addIntoCart(payload);
  };
}

export function getCart(sessionId) {
  return dispatch => {
    return getCartCall(sessionId).then(res => {
      if (res.status) {
        dispatch({
          type: GET_CART_REQUEST_SUCESSS,
          cart: Object.assign({}, res.data)
        });
      }
    });
  };
}

export function clearCart() {
  return dispatch => {
    dispatch({
      type: CLEAR_CART,
      cart: {}
    });
  };
}



// WEBPACK FOOTER //
// ./src/modules/actions/cartActions.js